var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.183,
    height: 6.001,
    viewBox: "0 0 10.183 6.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.968,9.264,11.5,12.8l3.536-3.536a.909.909,0,0,1,1.285,1.285l-4.183,4.183a.908.908,0,0,1-1.285,0L6.674,10.549a.907.907,0,0,1,0-1.285A.927.927,0,0,1,7.968,9.264Z",
    transform: "translate(16.591 14.998) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.1cc5a388.svg";
export { ForwardRef as ReactComponent };